
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/downloads",
      function () {
        return require("private-next-pages/support/downloads.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/downloads"])
      });
    }
  